// 引入api请求方法

import { waybillInvoiceList, waybillInvoiceExport } from '@/api/account';

const storeModuleName = 'routeTransferModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'input',
      param: 'waybillNo',
      value: '',
      valueType: 'string',
      label: '运单号',
      placeholder: '请输入运单号',
      clearable: true,
    },
  ],
  // tabs筛选项
  isSpecialTabs: false,
  isExport: {
    isShow: true,
    method: 'get',
    url: `${waybillInvoiceExport}?status=WAIT`,
  }, // 导出
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '运单号',
        prop: 'waybillNo',
        width: 130,
        checked: 1,
        sortable: true,
        isHide: false,
      },
      {
        label: '开票金额',
        prop: 'payAmt',
        width: 80,
        checked: 1,
        sortable: true,
        isHide: false,
        slotName: 'sub-domain-payAmt',
      },
      {
        label: '税额',
        prop: 'payAmount',
        width: 80,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-payAmount',
        isHide: false,
      },
      {
        label: '装货时间',
        prop: 'loadingTime',
        width: 110,
        checked: 1,
        sortable: true,
        isHide: false,
        slotName: 'sub-domain-loadingTime',
      },
      {
        label: '线路信息',
        prop: 'routeInfo',
        width: 120,
        checked: 1,
        sortable: true,
        isHide: false,
      },
      {
        label: '司机',
        prop: 'driverName',
        width: 80,
        checked: 1,
        sortable: true,
        isHide: false,
      },
      {
        label: '车辆',
        prop: 'vehicleNo',
        width: 80,
        checked: 1,
        sortable: true,
        isHide: false,
      },
      {
        label: '货物类型',
        prop: 'goodsType',
        width: 90,
        checked: 1,
        sortable: true,
      },

      {
        label: '货物名称',
        prop: 'goodsName',
        width: 80,
        checked: 1,
        sortable: true,
      },
      {
        label: '开票方',
        prop: 'channelInfoName',
        width: 100,
        checked: 1,
        sortable: true,
      },
    ],
  },
  companyList: [], // 企业列表
  companyInfo: '', // 当前选中的企业信息
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        params[item.param] = item.value;
      }
    });
    params.status = 'WAIT';
    const { data } = await waybillInvoiceList(Object.assign({}, params, context.state.postParams));
    context.commit('updateState', {
      key: 'listData',

      value: Object.assign(
        {},
        { list: data.records },
        { total: data.total },
        { tableHeadList: context.state.listData.tableHeadList },
      ),
    });
    return data.records;
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        item.value = '';
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
        break;
      default:
        break;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
